// extracted by mini-css-extract-plugin
module.exports = {"title":"MandatoryBlock_title__tkHAi","description":"MandatoryBlock_description___i1-R"};